<template>
  <div class="callout" :class="backgroundVariant">
    <div class="icon-wrapper">
      <img :src="require(`@/assets/${iconPath}`)">
    </div>
    <div class="text-wrapper">
      <div class="title" v-if="title">{{ title }}</div>
      <div class="text">
        <slot name="text"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Callout',
  props: {
    iconPath: { type: String, required: true },
    title: { type: String, required: false },
    backgroundVariant: { type: String, required: false, default: 'info' },
  },
};
</script>

<style scoped lang="scss">
  @import "../scss/riseup-colors";

  .callout {
    display: flex;
    flex-direction: row;
    border-radius: 8px;
    padding: 16px 10px;

    .icon-wrapper {
      display: flex;
      align-items: flex-start;
      margin-left: 10px;
      width: 24%;
      img {
        max-width: 100%;
        max-height: 100%;
      }
    }

    .text-wrapper {
      display: flex;
      flex-direction: column;
      font-size: 14px;
      line-height: 20px;

      .title {
        font-weight: bold;
      }
    }
  }

  .info {
    background-color: rgba($riseup_light_blue, 0.5);
  }
</style>
